import React from 'react';
import propTypes from 'prop-types';
export const FlightTicketIcon = ({ size, color, variant }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      width={sizeInPixel}
      height={sizeInPixel}
      className={variant}
      fill={color}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
      enableBackground="new 0 0 512 512"
      xmlSpace="preserve"
    >
      <g>
        <g>
          <g>
            <path
              d="M74.257,266.507l-12.101,12.099l24.006,12.104l12.103,24.006l12.099-12.099l-7.027-13.935l26.012-22.383l22.09,43.814
				l15.483-15.483l-14.648-48.055l8.835-7.602c0.144-0.136,0.293-0.276,0.433-0.415c6.383-6.385,6.427-16.783-0.008-23.218
				c-6.581-6.581-17.298-6.385-23.634,0.424c-4.229,4.91-5.553,6.454-7.599,8.833l-48.055-14.648l-15.486,15.483l43.814,22.09
				l-22.383,26.012L74.257,266.507z"
            />
            <path
              d="M494.153,202.231c9.857,0,17.847-7.991,17.847-17.847V97.015c0-9.857-7.991-17.847-17.847-17.847
				c-17.236,0-467.327,0-476.305,0C7.991,79.167,0,87.158,0,97.015v317.971c0,9.857,7.991,17.847,17.847,17.847
				c8.794,0,458.775,0,476.305,0c9.857,0,17.847-7.991,17.847-17.847v-87.369c0-9.857-7.991-17.847-17.847-17.847
				c-29.648,0-53.768-24.12-53.768-53.768C440.384,226.352,464.504,202.231,494.153,202.231z M206.051,397.139H35.695V114.863
				h170.357V397.139z M476.305,343.676v53.463H241.746V114.863h234.56v53.463c-40.81,8.293-71.616,44.454-71.616,87.675
				S435.496,335.383,476.305,343.676z"
            />
            <path
              d="M374.494,174.845h-82.506c-9.857,0-17.847,7.991-17.847,17.847c0,9.857,7.991,17.848,17.847,17.848h82.506
				c9.857,0,17.847-7.991,17.847-17.848C392.341,182.835,384.35,174.845,374.494,174.845z"
            />
            <path
              d="M291.987,273.849h70.608c9.857,0,17.847-7.991,17.847-17.847s-7.991-17.847-17.847-17.847h-70.608
				c-9.857,0-17.847,7.991-17.847,17.847S282.13,273.849,291.987,273.849z"
            />
            <path
              d="M374.494,301.462h-82.506c-9.857,0-17.847,7.991-17.847,17.847s7.991,17.847,17.847,17.847h82.506
				c9.857,0,17.847-7.991,17.847-17.847S384.35,301.462,374.494,301.462z"
            />
          </g>
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
};
FlightTicketIcon.propTypes = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};
FlightTicketIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
